const mutations = {
  SET_APPS (state, apps) {
    state.apps = apps
  },
  SET_APP_DETAIL (state, app) {
    state.detail = app
  },
  SET_APPLICATION_CATEGORIES (state, categories) {
    state.categories = categories
  },
  SET_EVENTS (state, events) {
    state.events = events
  },
  SET_ACTIONS (state, actions) {
    state.actions = actions
  },
  UPDATE_GENERAL_DATA (state, generalData) {
    state.detail.name = generalData.name
    state.detail.classification.category = generalData.classification.category
    state.detail.classification.type = generalData.classification.type
    state.detail.support_email = generalData.support_email
    state.detail.app_url = generalData.app_url
  },
  UPDATE_DESCRIPTIONS (state, descriptions) {
    state.detail.descriptions = descriptions
  },
  UPDATE_CALLBACKS (state, callbacks) {
    state.detail.webhooks_url = callbacks.webhooks_url
    state.detail.webhooks_develop_url = callbacks.webhooks_develop_url
    state.detail.hub_callback_url = callbacks.hub_callback_url
    state.detail.hub_callback_develop_url = callbacks.hub_callback_develop_url
    state.detail.validation_callback_url = callbacks.validation_callback_url
    state.detail.validation_callback_developUrl = callbacks.validation_callback_developUrl
  },
  UPDATE_PERMISSIONS (state, permissions) {
    state.detail.events = permissions.events
    state.detail.optional_events = permissions.optional_events
    state.detail.actions = permissions.actions
    state.detail.optionalActions = permissions.actions
  },
  UPDATE_SECURITY (state, security) {
    state.detail.security = security
  },
  UPDATE_ADDITIONAL_DATA (state, addData) {
    state.detail.additional_data = addData
  },
  UPDATE_IMAGES (state, images) {
    state.detail.avatar = images.avatar
    state.detail.banners = images.banners
    state.detail.color = images.color
  }
}

export default mutations
